<template>
  <div class="d-flex flex-column mt-n1">
    <div class="primary--text text--lighten-1 text-body-1 font-weight-regular">
      Condomínio
    </div>

    <v-radio-group v-model="model" class="mt-0" hide-details dense row>
      <v-radio class="mr-4 mt-0" name="condominio" label="Sim" value="sim" />
      <v-radio class="mt-0" name="condominio" label="Não" value="nao" />
    </v-radio-group>
  </div>
</template>

<script>
const _data = {
  model: null,
};

export default {
  data: () => ({
    ..._data,
  }),
  watch: {
    $route(v) {
      this.model = v.query.condominio ? v.query.condominio : null;
    },
  },
  mounted() {
    if (this.$route.query.condominio) this.model = this.$route.query.condominio;
  },
};
</script>
